import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerHiddenArticleTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution, type HiddenArticleSolution } from "./solution";
import type {
  HiddenArticleDefinition,
  HiddenArticleProgress,
  HiddenArticleSubmission,
} from "./types";

registerHiddenArticleTranslations(i18n);

/**
 * No `localFeedback`: revealing needs the words and the vectors, which stay server-side.
 * `applyVerdict` is what makes the server's reading of the page part of the autosaved
 * progress (ADR 0041, 0042).
 */
export const hiddenArticleModule: PuzzleTypeModule<
  HiddenArticleDefinition,
  HiddenArticleSubmission,
  HiddenArticleProgress,
  HiddenArticleSolution
> = {
  key: "hidden_article",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
